<template>
  <div v-loading.fullscreen.lock="loading" class="record_list">
    <!-- 头部 -->
    <top-part :rightPart="true"></top-part>
    <!-- 头部 结束 -->

    <div v-if="dataList && dataList.length" class="ctn_top">
      <div
        class="data_list"
        v-infinite-scroll="loadMore"
        infinite-scroll-distance="50"
      >
        <div
          v-for="(item, index) in dataList"
          :key="index"
          @click="toDetail(item)"
        >
          <div class="list_left">
            <img :src="item.productImage" />
            <div class="img_text">
              <div class="list_title">{{ item.productName }}</div>
              <div class="list_count">x1</div>
            </div>
          </div>
          <div class="list_time">{{ item.createDate }}</div>
        </div>
      </div>

      <p class="nomore" v-if="noMore">
        ———&nbsp;&nbsp;&nbsp;&nbsp;没有更多了&nbsp;&nbsp;&nbsp;&nbsp;———
      </p>
    </div>
    <!-- 没数据时 -->
    <div class="blank" v-if="(!dataList || !dataList.length) && !loading">
      <img src="@/images/404-02.png" alt />
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import topPart from "../../components/topPart";
import { toast } from "@/common/api/api.js";
export default {
  components: {
    topPart
  },
  data() {
    return {
      loading:true,
      dataList:[],//兑换列表
      currentPage:1,
      noMore: true, //是否展示更多
    };
  },
  mounted(){
    // console.log('参数',this.$route.query)
    this.queryFn();
  },
  methods:{
    loadMore(){
      // this.currentPage++;
      // this.queryFn();
    },
    queryFn(){
      this.loading = true;
      const{welfareCategory} = this.$route.query  //根据传过来的标识判断是生日慰问还是节日慰问
      let params = {
        // currentPage:this.currentPage,
        // pageSize:1,
        welfareCategory: welfareCategory
      }
      this.centralControl.axios.centralControl(
        "orderList",
        res => {
          const {code,message,data} = res;
          this.loading = false;
          if (code == 200) {
            const {list,total}=data;
            this.dataList = [...this.dataList, ...list];
            if (this.dataList.length > 0 && list == 0) {
              this.noMore = true;
              return;
            }
          } else {
            toast(this, message,"error");
          }
        },
        // {}
        params
      );
    },
    toDetail(item){
      const{welfareCategory} = this.$route.query //根据传过来的标识判断是生日慰问还是节日慰问

      this.$router.push({
        path: 'exchangeDetail',
        query: {
          id:item.id,
          detailsType: welfareCategory
        }
      })
    },
  }
}
</script>
<style lang="stylus" type="stylesheet/stylus">
@import "../../assets/stylus/common"
  .record_list{
    .data_list {
      >div {
        border-bottom: 1px solid #F5F6FB;
        background: #FFF;
        padding: 9px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .list_left {
          display: flex;
          .img_text {
            display: flex;
            flex-direction: column;
            justify-content:space-between;
          }
        }
        img {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }
      }
      .list_title{
        font-size:16px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(53,53,53,1);
      }
      .list_count {
        font-size:13px;
        font-family:PingFang-SC-Medium,PingFang-SC;
        font-weight:500;
        color:rgba(202,202,210,1);
      }
      .list_time {
        font-size:13px;
        font-family:PingFang-SC-Medium,PingFang-SC;
        font-weight:500;
        color:rgba(202,202,210,1);
      }
    }

    .nomore {
      font-size: 13px;
      padding-bottom: 10px;
      text-align: center;
      color:rgba(202,202,210,1);
      line-height: 40px;
    }
  }
</style>
